import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react'

export default function DatePicker(props) {
    const { name, label, value, onChange, ...rest } = props;

    const handleOnChange = (name, value) => ({
        target: { name, value }
    })

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MUIDatePicker
                label={label}
                value={value}
                onChange={e => onChange(handleOnChange(name, e))}
                inputFormat="MMM/dd/yyyy"
                name={name}
                {...rest}
                renderInput={(params) => <TextField fullWidth {...params} />}
            />
        </LocalizationProvider>
    )
}
